export enum NavigationTab {
    Character = "character",
    Journal = "journal",
    Leaderboard = "leaderboard",
    Quests = "quests",
    Dashboard = "dashboard",
    Play = "play",
}
